import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const StageHistorySlider = ({ isOpen, onClose, stageHistory = [], pipelines = [], currentPipelineId }) => {

  const styles = {
    content: {
      padding: '10px',
      height: '88vh',
      overflowY: 'auto'
    },
    timeline: {
      position: 'relative'
    },
    item: {
      display: 'flex',
      marginBottom: '15px',
      position: 'relative'
    },
    marker: {
      position: 'relative',
      marginRight: '20px',
      width: '20px'
    },
    dot: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: 'transprent',
      border: '2px solid #2E2C9A',
      position: 'relative',
      zIndex: 1
    },
    line: {
      position: 'absolute',
      top: '12px',
      left: '5px',
      width: '1px',
      height: 'calc(100% + 5px)',
      border: 'dashed 1px rgb(46, 44, 154)'
    },
    stageContent: {
      flex: 1,
      backgroundColor: '#FBFCFF',
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #EFF4F9'
    },
    stageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px'
    },
    stageName: {
      fontSize: '13px',
      fontWeight: '600',
      color: 'var(--primary-color)',
      margin: 0
    },
    duration: {
      fontSize: '12px',
      color: '#4b5563',
      backgroundColor: '#F8F9FF',
      padding: '2px 8px',
      borderRadius: '4px'
    },
    dateInfo: {
      display: 'flex',
      gap: '8px',
      marginBottom: '5px',
      fontSize: '12px'
    },
    dateLabel: {
      color: '#4b5563',
      fontWeight: '500'
    },
    dateValue: {
      color: '#1f2937'
    },
    changedBy: {
      marginTop: '10px',
      paddingTop: '10px',
      borderTop: '1px solid #e5e7eb',
      fontSize: '12px',
      display: 'flex',
      gap: '8px'
    },
    emptyState: {
      textAlign: 'center',
      padding: '40px',
      color: '#4b5563'
    }
  };

  // Get current pipeline to map stage IDs to names
  const currentPipeline = pipelines.find(p => p['_id'] === currentPipelineId);

  // Helper to get stage name from stage ID
  const getStageName = (stageId) => {
    if (!currentPipeline) return stageId;
    const stage = currentPipeline['stages']?.find(s => s['id'] === stageId);
    return stage?.['name'] || stageId;
  };

  // Helper to format duration
  const formatDuration = (days) => {
    if (!days && days !== 0) return '-';
    if (days === 0) return 'Less than a day';
    if (days === 1) return '1 day';
    return `${days} days`;
  };

  // Sort stage history by enteredAt date (most recent first)
  const sortedHistory = [...(stageHistory || [])].sort((a, b) =>
    new Date(b['enteredAt']) - new Date(a['enteredAt'])
  );

  return (
    <Modal
      isOpen={isOpen}
      modalClassName='right right-without-bg'
      backdrop={false}
      className='main-modal right right-side-modal stage-history-modal'
    >
      <ModalHeader toggle={onClose}>
        <h3>Stage History</h3>
      </ModalHeader>
      <ModalBody>
        <div style={styles.content} className='stage-history-content'>
          {sortedHistory.length === 0 ? (
            <div style={styles.emptyState}>
              <p>No stage history available</p>
            </div>
          ) : (
            <div style={styles.timeline}>
              {sortedHistory.map((entry, index) => (
                <div key={index} style={styles.item}>
                  <div style={styles.marker}>
                    <div style={styles.dot}></div>
                    {index < sortedHistory.length - 1 && <div style={styles.line}></div>}
                  </div>

                  <div style={styles.stageContent}>
                    <div style={styles.stageHeader}>
                      <h4 style={styles.stageName}>{getStageName(entry['stage'])}</h4>
                      {entry['duration'] !== undefined && (
                        <span style={styles.duration}>{formatDuration(entry['duration'])}</span>
                      )}
                    </div>

                    <div>
                      <div style={styles.dateInfo}>
                        <span style={styles.dateLabel}>Entered:</span>
                        <span style={styles.dateValue}>
                          {entry['enteredAt'] ? new Date(entry['enteredAt']).toLocaleString() : '-'}
                        </span>
                      </div>

                      {entry['exitedAt'] && (
                        <div style={styles.dateInfo}>
                          <span style={styles.dateLabel}>Exited:</span>
                          <span style={styles.dateValue}>
                            {new Date(entry['exitedAt']).toLocaleString()}
                          </span>
                        </div>
                      )}
                    </div>

                    {entry['changedBy'] && (
                      <div style={styles.changedBy}>
                        <span style={styles.dateLabel}>Changed by:</span>
                        <span style={styles.dateValue}>
                          {entry['changedBy']['firstName'] ?
                            `${entry['changedBy']['firstName']} ${entry['changedBy']['lastName']}` :
                            entry['changedBy']['email'] || 'System'}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default StageHistorySlider;